var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shopInfo" },
    [
      _c(
        "div",
        { staticClass: "relative" },
        [
          _vm.isOpenType == 2
            ? [
                _c("div", { staticClass: "link link-one-other absolute" }),
                _c("div", { staticClass: "link link-two-other absolute" })
              ]
            : [
                _c("div", { staticClass: "link link-one absolute" }),
                _c("div", { staticClass: "link link-two absolute" })
              ],
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "93px"
              }
            },
            [
              _vm.isOpenType == 2
                ? [
                    _c("div", { staticClass: "form-step fb mar20-b f16" }, [
                      _c("span", { staticClass: "mar20-r white f12" }, [
                        _vm._v("1")
                      ]),
                      _vm._v(" 选择企业")
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex mar50-l mar20-b" },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "w613",
                            attrs: {
                              filterable: "",
                              remote: "",
                              "reserve-keyword": "",
                              placeholder: "请输入关键词",
                              "remote-method": _vm.queryOrgList
                            },
                            on: { change: _vm.getPackage },
                            model: {
                              value: _vm.seachOrgId,
                              callback: function($$v) {
                                _vm.seachOrgId = $$v
                              },
                              expression: "seachOrgId"
                            }
                          },
                          _vm._l(_vm.seachOrgList, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.name + "-" + item.adminName,
                                value: item.id
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.isOpenType == 2
                ? _c("div", { staticClass: "form-step fb mar20-b f16" }, [
                    _c("span", { staticClass: "mar20-r white f12" }, [
                      _vm._v("2")
                    ]),
                    _vm._v(" 版本选择")
                  ])
                : _vm._e(),
              _vm.isOpenType != 2
                ? _c("div", { staticClass: "form-step fb mar20-b f16" }, [
                    _c("span", { staticClass: "mar20-r white f12" }, [
                      _vm._v("1")
                    ]),
                    _vm._v(" 版本选择")
                  ])
                : _vm._e(),
              _c("div", { staticClass: "flex mar50-l mar20-b" }, [
                _c(
                  "div",
                  {
                    staticClass: "pad20 mar20-r border-gray9 radius5 pointer",
                    class: { borBlue: _vm.shopType === "MICRO_STORE" },
                    on: {
                      click: function($event) {
                        return _vm.changeShop("MICRO_STORE")
                      }
                    }
                  },
                  [
                    _c("p", { staticClass: "f16" }, [_vm._v("订到-微店版")]),
                    _c("p", { staticClass: "f12 gray9 mar5-t" }, [
                      _vm._v("一键快速拥有品牌专属小程序")
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "pad20 mar20-r border-gray9 radius5 pointer",
                    class: { borBlue: _vm.shopType === "ORDER_GOODS" },
                    on: {
                      click: function($event) {
                        return _vm.changeShop("ORDER_GOODS")
                      }
                    }
                  },
                  [
                    _c("p", { staticClass: "f16" }, [_vm._v("订到-订货版")]),
                    _c("p", { staticClass: "f12 gray9 mar5-t" }, [
                      _vm._v("告别电话订货，让客户线上订货")
                    ])
                  ]
                )
              ]),
              _c("div", { staticClass: "form-step fb mar20-b f16" }, [
                _c("span", { staticClass: "mar20-r white f12" }, [_vm._v("2")]),
                _vm._v(" 经营信息")
              ]),
              _c(
                "div",
                { staticClass: "mar50-l" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺名称：", prop: "name" } },
                    [
                      _c("el-input", {
                        staticClass: "w520",
                        attrs: { placeholder: "请填写名称" },
                        model: {
                          value: _vm.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "经营类目：", prop: "type" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.type,
                            callback: function($$v) {
                              _vm.type = $$v
                            },
                            expression: "type"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            { attrs: { label: "1", name: "农资" } },
                            [_vm._v(" " + _vm._s("农资"))]
                          ),
                          _c(
                            "el-checkbox",
                            { attrs: { label: "2", name: "农牧" } },
                            [_vm._v(" " + _vm._s("农牧"))]
                          ),
                          _c(
                            "el-checkbox",
                            { attrs: { label: "3", name: "水产品" } },
                            [_vm._v(" " + _vm._s("水产品"))]
                          ),
                          _c(
                            "el-checkbox",
                            { attrs: { label: "4", name: "农产品" } },
                            [_vm._v(" " + _vm._s("农产品"))]
                          ),
                          _c(
                            "el-checkbox",
                            { attrs: { label: "5", name: "禽蛋" } },
                            [_vm._v(" " + _vm._s("禽蛋"))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "addr-select",
                      attrs: { label: "所在地：" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择省/市" },
                          on: { change: _vm.provinceChange },
                          model: {
                            value: _vm.indProvince,
                            callback: function($$v) {
                              _vm.indProvince = $$v
                            },
                            expression: "indProvince"
                          }
                        },
                        _vm._l(_vm.province, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择市/县" },
                          on: { change: _vm.cityChange },
                          model: {
                            value: _vm.indCity,
                            callback: function($$v) {
                              _vm.indCity = $$v
                            },
                            expression: "indCity"
                          }
                        },
                        _vm._l(_vm.city, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择县" },
                          on: { change: _vm.countryChange },
                          model: {
                            value: _vm.indCountry,
                            callback: function($$v) {
                              _vm.indCountry = $$v
                            },
                            expression: "indCountry"
                          }
                        },
                        _vm._l(_vm.country, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择乡镇" },
                          on: { change: _vm.townshipChange },
                          model: {
                            value: _vm.indTownship,
                            callback: function($$v) {
                              _vm.indTownship = $$v
                            },
                            expression: "indTownship"
                          }
                        },
                        _vm._l(_vm.township, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      ),
                      _vm.addShow
                        ? _c("p", { staticClass: "tagInfo" }, [
                            _vm._v("请选择省市县")
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "详细地址：", prop: "address" } },
                    [
                      _c("el-input", {
                        staticClass: "w520",
                        attrs: { placeholder: "请填写详细地址" },
                        model: {
                          value: _vm.form.addr,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "addr", $$v)
                          },
                          expression: "form.addr"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isOpenType == 2
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.onSubmitOpen()
                                }
                              }
                            },
                            [_vm._v("立即开通")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.isOpenType != 2
                ? _c("div", { staticClass: "form-step fb mar20-b f16" }, [
                    _c("span", { staticClass: "mar20-r white f12" }, [
                      _vm._v("3")
                    ]),
                    _vm._v(" 服务订购")
                  ])
                : _vm._e(),
              _vm.isOpenType != 2
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "mar50-l",
                          attrs: { label: "总计费用：" }
                        },
                        [
                          _vm.goodsPriceLoading
                            ? _c("p", { staticClass: "f28 mar10-r" }, [
                                _c("i", { staticClass: "el-icon-loading" })
                              ])
                            : _vm._e(),
                          !_vm.goodsPriceLoading
                            ? _c("span", { staticClass: "f30 mar-15-l" }, [
                                _vm._v(
                                  "￥" +
                                    _vm._s(
                                      _vm.goodsDetail.goodsPrice.sellFactPrice
                                    )
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "mar50-l mar20-b" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "w150",
                              attrs: {
                                type: "primary",
                                loading: !_vm.isSubmit
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onSubmit("")
                                }
                              }
                            },
                            [_vm._v(" 立即订购 ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm.orderList && _vm.orderList.length > 0 && _vm.isOpenType != 2
            ? _vm._l(_vm.orderList, function(item) {
                return _c(
                  "div",
                  {
                    key: item.order.orderId,
                    staticClass: "w600 pad10 border-gray9 radius5 mar40-b"
                  },
                  [
                    _c("p", { staticClass: "mar10-b f12" }, [
                      _vm._v("你有未完成支付的订单，可直接支付")
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-between" },
                      [
                        _c("div", { staticClass: "flex" }, [
                          _c("img", {
                            staticClass: "w70 h70",
                            attrs: {
                              src:
                                item.orderGoods[0].goodsPic +
                                "?imageView2/1/w/100/h/100"
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-column justify-between mar10-l"
                            },
                            [
                              _c("p", { staticClass: "f16" }, [
                                _vm._v(_vm._s(item.orderGoods[0].goodsName))
                              ]),
                              _c("p", { staticClass: "f12 gray6" }, [
                                _vm._v(_vm._s(_vm.goodsDetail.nmGoodsIntroduce))
                              ]),
                              _c("p", { staticClass: "f12 gray6" }, [
                                _vm._v(
                                  "x " +
                                    _vm._s(item.orderGoods[0].goodsQuantity)
                                )
                              ])
                            ]
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "flex items-center" },
                          [
                            _c("p", { staticClass: "f28 mar20-r" }, [
                              _vm._v("￥" + _vm._s(item.order.fMoneyStr))
                            ]),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onSubmit(item.order.orderId)
                                  }
                                }
                              },
                              [_vm._v("去支付")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              })
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.centerDialogVisible,
            width: "80%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.centerDialogVisible = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "span",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.centerDialogVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.centerDialogVisible = false
                            }
                          }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "amap-page-container" }, [
            _c(
              "div",
              { style: { width: "100%", height: "300px" } },
              [
                _c("el-amap", {
                  staticClass: "amap-demo",
                  attrs: { vid: "amap", plugin: _vm.plugin }
                })
              ],
              1
            )
          ])
        ]
      ),
      _c("agreement", {
        attrs: { visible: _vm.readAgreementVisible },
        on: {
          "update:visible": function($event) {
            _vm.readAgreementVisible = $event
          }
        }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isSuccess,
              expression: "isSuccess"
            }
          ],
          staticClass: "shopSuccess"
        },
        [
          _c("img", { attrs: { src: require("./shop_success.png"), alt: "" } }),
          _c("div", { staticClass: "box15" }),
          _c("p", [_vm._v("恭喜，系统开通成功")])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }